<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消息详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="msgTitle">邀请好友成功</div>
            <div class="msgContent">
                <p>亲爱的玲玲：</p>
                <p>您好友成成有一张上林时光（上街店）的普通会员卡，邀请您一起共享!</p>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
export default {
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1'   
    };
  },
  computed: {},
  components: {},
  methods: {     
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.msgTitle{
    text-align: center;
    font-size: 0.37rem;
    color: #101010;
    margin-top: 0.66rem;
    font-weight: 600;
}
.msgContent{
    width: 7.87rem;
    height: auto;
    font-size: 0.37rem;
    margin-left: 0.97rem;
    margin-top: 0.4rem;
}
.msgContent :nth-child(2){
    text-indent: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/messageDetails/inviteVip.vue